import { WEB_SOURCE_ICON } from '#pplx/frontend/apps/ask/shared/sourceIcons.js';
import { $icon } from '#pplx/frontend/icons/icon-sprite.js';
const ALL_CORE_SOURCES = ['web', 'scholar', 'my_files', 'health'];
export const isCoreSourceType = (sourceId) => {
    return ALL_CORE_SOURCES.includes(sourceId);
};
export const CORE_SOURCES = {
    web: {
        type: 'web',
        icon: WEB_SOURCE_ICON,
        label: (intl) => intl.formatMessage({
            defaultMessage: 'Web',
            id: '8302336103',
            description: 'Label for web search source',
        }),
        description: (intl) => intl.formatMessage({
            defaultMessage: 'Search across the entire Internet',
            id: 'a3b981f02b',
            description: 'Description for web search source',
        }),
    },
    scholar: {
        type: 'scholar',
        icon: $icon('books'),
        label: (intl) => intl.formatMessage({
            defaultMessage: 'Academic',
            id: '09f836fc57',
            description: 'Label for academic papers search source',
        }),
        description: (intl) => intl.formatMessage({
            defaultMessage: 'Search academic papers',
            id: 'ae08aecfc4',
            description: 'Description for academic papers search source',
        }),
    },
    my_files: {
        type: 'my_files',
        icon: $icon('file-export'),
        label: (intl) => intl.formatMessage({
            defaultMessage: 'My files',
            id: 'b99af04b49',
            description: 'Label for personal files search source',
        }),
        description: (intl) => intl.formatMessage({
            defaultMessage: 'Search my files',
            id: 'd8db7bc856',
            description: 'Description for personal files search source',
        }),
    },
    health: {
        type: 'health',
        icon: $icon('custom-perplexity-health'),
        label: (intl) => intl.formatMessage({
            defaultMessage: 'Health',
            id: '1da5ce683e',
            description: 'Label for health search source',
        }),
        description: (intl) => intl.formatMessage({
            defaultMessage: 'Access your health and wellness data',
            id: 'cbabee4f69',
            description: 'Description for health search source',
        }),
    },
};
//# sourceMappingURL=coreSourcesConfig.js.map